import Vue from 'vue'
import Router from 'vue-router'
import Lodash from 'lodash'

Vue.use(Router)

// 主入口
const main = [{
    path: '/',
    name: 'home',
    meta: { title: '课程' },
    component: resolve => require(['@/components/course.vue'], resolve)
  }, {
    path: '/mycourse',
    name: 'mycourse',
    meta: { title: '课程表' },
    component: resolve => require(['@/components/mycourse.vue'], resolve)
  },
  {
    path: '/course',
    name: 'course',
    meta: { title: '课程' },
    component: resolve => require(['@/components/course.vue'], resolve)
  },
  {
    path: '/profession',
    name: 'profession',
    meta: { title: '微专业' },
    component: resolve => require(['@/components/profession.vue'], resolve)
  },
  {
    path: '/center',
    name: 'center',
    meta: { title: '我的' },
    component: resolve => require(['@/components/center.vue'], resolve)
  }
]

// 登录 & 注册
const login = [{
  path: '/login',
  name: 'login',
  meta: { title: '登录' },
  component: resolve => require(['@/components/login.vue'], resolve)
}, {
  path: '/set/psswd',
  name: 'set.psswd',
  meta: { title: '注册' },
  component: resolve => require(['@/components/user.set.passwd.vue'], resolve)
},{
  path: '/reset/psswd',
  name: 'reset.psswd',
  meta: { title: '重置密码' },
  component: resolve => require(['@/components/user.reset.psswd.vue'], resolve)
}]

// 个人信息
const user = [{
  path: '/identify',
  name: 'identify',
  meta: { title: '认证信息' },
  component: resolve => require(['@/components/user.identify.vue'], resolve)
}]

// 课程
const course = [{
    path: '/course/search',
    name: 'course.search',
    meta: { title: '课程搜索' },
    component: resolve => require(['@/components/course.search.vue'], resolve)
  },
  {
    path: '/course/detail/:id',
    name: 'course.detail',
    meta: { title: '课程详情' },
    component: resolve => require(['@/components/course.detail.vue'], resolve)
  }
]

// 微专业
const profession = [{
  path: '/profession/:id',
  name: 'profession.detail',
  meta: { title: '微专业详情' },
  component: resolve => require(['@/components/profession.detail.vue'], resolve)
}];


// 支付
const pay = [{
  path: '/pay/:id',
  name: 'pay.info',
  meta: { title: '购买' },
  component: resolve => require(['@/components/pay.create.vue'], resolve)
}, {
  path: '/pay/result/:id',
  name: 'pay.result',
  meta: { title: '支付完成' },
  component: resolve => require(['@/components/pay.result.vue'], resolve)
},{
  path: '/pay/success/:id',
  name: 'pay.success',
  meta: { title: '购买成功' },
  component: resolve => require(['@/components/pay.success.vue'], resolve)
}, {
  path: '/pay/error/:id',
  name: 'pay.error',
  meta: { title: '购买失败' },
  component: resolve => require(['@/components/pay.error.vue'], resolve)
}];

const statement = [{
  path: '/statement/apply',
  name: 'statement.apply',
  meta: { title: '用户使用协议' },
  component: resolve => require(['@/components/statement.apply.vue'], resolve)
}, {
  path: '/statement/pay',
  name: 'statement.pay',
  meta: { title: '用户付费协议' },
  component: resolve => require(['@/components/statement.pay.vue'], resolve)
}]

const bee = [{
  path: '/bee/center',
  name: 'bee.center',
  meta: { title: '我的奖金' },
  component: resolve => require(['@/components/bee.center.vue'], resolve)
}, {
  path: '/bee/statement',
  name: 'bee.statement',
  meta: { title: '校园大使组织条款' },
  component: resolve => require(['@/components/bee.statement.vue'], resolve)
}, {
  path: '/bee/withdrawcash',
  name: 'bee.withdrawcash',
  meta: { title: '申请提现' },
  component: resolve => require(['@/components/bee.withdrawcash.vue'], resolve)
}, {
  path: '/bee/withdrawcash/history',
  name: 'bee.withdrawcash.history',
  meta: { title: '提现记录' },
  component: resolve => require(['@/components/bee.withdrawcash.history.vue'], resolve)
}, {
  path: '/bee/intro',
  name: 'bee.intro',
  meta: { title: '优课校园大使介绍' },
  component: resolve => require(['@/components/bee.intro.vue'], resolve)
}, {
  path: '/bee/status/:status',
  name: 'bee.status',
  meta: { title: '优课校园大使申请' },
  component: resolve => require(['@/components/bee.status.vue'], resolve)
}, {
  path: '/bee/promotion',
  name: 'bee.promotion',
  meta: { title: '如何快速提升销量' },
  component: resolve => require(['@/components/bee.promotion.vue'], resolve)
}]

const coupon = [{
  path: '/coupon/list',
  name: 'coupon.list',
  meta: { title: '优惠券' },
  component: resolve => require(['@/components/coupon.list.vue'], resolve)
}, {
  path: '/coupon/info/:id',
  name: 'coupon.info',
  meta: { title: '领取优惠券' },
  component: resolve => require(['@/components/coupon.info.vue'], resolve)
}, {
  path: '/coupon/tel/:id',
  name: 'coupon.tel',
  meta: { title: '领取优惠券' },
  component: resolve => require(['@/components/coupon.tel.vue'], resolve)
}]

// 合并路由
const routes = Lodash.concat(main, login, user, pay, course, profession, statement, bee, coupon)
export default new Router({ routes })



// WEBPACK FOOTER //
// ./src/router/index.js